import { Trailer as ITrailer } from "@filmweb/sanity-types";

const DocType_Trailer = "trailer";

export { DocType_Trailer };
export type { ITrailer };
